export { default as Loader } from './loader';
